import { Link } from "react-router-dom";
import { mediaList } from "@/mocks/media";
import { newsList } from "@/mocks/news";

const movieCount = mediaList.filter((item) => item.type === "movie").length;
const tvCount = mediaList.filter((item) => item.type === "tv").length;

const entries = [
  {
    to: "/category/movie",
    icon: "ri-film-line",
    label: "电影",
    desc: "最新院线大片与高分经典",
    count: `${movieCount}+ 部佳片`,
  },
  {
    to: "/category/tv",
    icon: "ri-tv-2-line",
    label: "电视剧",
    desc: "热播剧集与全集内容",
    count: `${tvCount}+ 部热剧`,
  },
  {
    to: "/news",
    icon: "ri-newspaper-line",
    label: "影视资讯",
    desc: "行业动态与影评精选",
    count: `${newsList.length}+ 篇资讯`,
  },
];

export default function CategoryEntries() {
  return (
    <section className="mx-auto max-w-[1280px] px-4 md:px-6">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 md:gap-5">
        {entries.map((entry) => (
          <Link
            key={entry.to}
            to={entry.to}
            className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 hover:bg-primary-50/60"
          >
            <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-lg bg-primary-500 text-background-50 transition-colors group-hover:bg-accent-500 md:h-16 md:w-16">
              <i className={`${entry.icon} text-2xl md:text-3xl`} aria-hidden="true"></i>
            </span>
            <span className="min-w-0 flex-1">
              <span className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                {entry.label}
                <i
                  className="ri-arrow-right-up-line text-primary-500 transition-transform group-hover:translate-x-0.5"
                  aria-hidden="true"
                ></i>
              </span>
              <span className="mt-1 block truncate text-sm text-foreground-500">{entry.desc}</span>
              <span className="mt-1.5 inline-block rounded-md bg-secondary-100 px-2 py-0.5 text-xs font-medium text-secondary-900">
                {entry.count}
              </span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}